export enum TypesOrder {
    SENT = 'sent',
    COLLECTION = 'collection',
    READY = 'ready',
    RECEIVED = 'received',
    CANCELLED = 'cancelled'
}
